import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { editProfile, fetchCustomer } from "../../services/userService";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const UpdateProfile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const { customer , loader, errors: errosForm,isSuccess} = useSelector((state) => state.customer);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors: formErrors },
  } = useForm({
    defaultValues: {
      firstName: customer?.firstName || "",
      lastName: customer?.lastName || "",
      address: customer?.address || "",
      phone: customer?.phone || "",
    },
  });
  const onSubmit = (data) => {
    dispatch(editProfile(data));
  };

  useEffect(() => {
    dispatch(fetchCustomer());
  }, [dispatch]);

  return (
    <>
      {isSuccess &&
        toast.success("customer is update", {
          position: toast.TOP_RIGHT,
        })}

      {errosForm?.length > 0 && (
        <div className="flex justify-between py-4 px-8 bg-[#fad2e1]  text-[#7c193d]">
          <ul>
            {errosForm?.map((error, key) => (
              <li key={key} className="font-medium">
                {error}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="flex">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="bg-white px-8 pt-6 pb-8 mb-4 w-full max-w-sm"
        >
          {" "}
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t("register.form.firstName.label")}
            </label>
            <input
              {...register("firstName", {
                required: t("register.form.firstName.required"),
                minLength: {
                  value: 6,
                  message: t("register.form.firstName.message"),
                },
              })}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
            />
            {formErrors.firstName && (
              <p className="text-red-500 text-xs mt-1">
                {formErrors.firstName.message}
              </p>
            )}
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t("register.form.lastName.label")}
            </label>
            <input
              {...register("lastName", {
                required: t("register.form.lastName.required"),
                minLength: {
                  value: 6,
                  required: t("register.form.lastName.required"),
                },
              })}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
            />
            {formErrors.lastName && (
              <p className="text-red-500 text-xs mt-1">
                {formErrors.lastName.message}
              </p>
            )}
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t("register.form.phone.label")}
            </label>
            <input
              {...register("phone", {
                required: t("register.form.phone.required"),
                minLength: {
                  value: 6,
                  message: t("register.form.phone.max"),
                },
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Phone number must be 10 digits",
                },
              })}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
            />
            {formErrors.phone && (
              <p className="text-red-500 text-xs mt-1">
                {formErrors.phone.message}
              </p>
            )}
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t("register.form.address.label")}
            </label>
            <input
              {...register("address", {
                required: t("register.form.address.required"),
                minLength: {
                  value: 6,
                  message: t("register.form.address.max"),
                },
              })}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
            />
            {formErrors.address && (
              <p className="text-red-500 text-xs mt-1">
                {formErrors.address.message}
              </p>
            )}
          </div>
          <button
            type="submit"
            className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full ${
              loader ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loader}
          >
            {loader ? "Saving..." : "Update"}
          </button>
        </form>
      </div>
    </>
  );
};

export default UpdateProfile;
